import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { PatientService } from 'src/app/services/patient/patient.service';
import { ReferentielService } from 'src/app/services/referentiel/referentiel.service';
import { ReferentielEnum } from 'src/app/utils/enums/referentiel-enum';
import { FamillePatient } from 'src/app/utils/interfaces/new/famille-patient.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { Patient } from 'src/app/utils/interfaces/new/patient.interface';
import { Referentiel } from 'src/app/utils/interfaces/new/referentiel.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-histo-contact',
  templateUrl: './parent-patient.fragment.html',
  styleUrls: [
    './parent-patient.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class ParentPatientFragment implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeFamilleModal();
    }
  }

  @Output() public closeEmitter = new EventEmitter();

  public idPatient: string;
  public listParent: Paginated<FamillePatient>;
  public parentColumnTable: any;
  public listAllPatient: Patient[];
  public refParente: Referentiel[]

  constructor(
    private _ref: ReferentielService,
    private _patient: PatientService,
  ) { }

  async ngOnInit(): Promise<void> {
    await this.refresh();
  }

  async refresh() {
    this.listAllPatient = await this._patient.findAll();
    this.refParente = await this._ref.findRefListTable(ReferentielEnum.parente);
    const parents = await this._patient.findOnePatientFamille(this.idPatient);
    for (let parent of parents) {
      Object.defineProperty(parent, 'id', { value: parent.idParent + parent.idParente + parent.idPatient });
    }
    this.parentColumnTable = [
      { title: 'Parent', data: 'idParent', isEditable: true, editType: 'ngSelect', editValue: this.listAllPatient, validators: [Validators.required] },
      { title: 'Lien', data: 'idParente', isEditable: true, editType: 'ngSelect', editValue: this.refParente, validators: [Validators.required] },
      { title: 'Supprimer', data: null }
    ];
    this.listParent = {
      objects: parents,
      total: parents.length,
      page: 1,
      perpage: -1,
    }
  }

  changeParents(event: any) {
    for (let parent of event) {
      const index = this.listParent.objects.findIndex(x => x.idParent === parent.idParent && x.idPatient === this.idPatient);
      if (index > -1) {
        this.listParent.objects[index] = {
          idPatient: this.idPatient,
          idParent: parent.idParent,
          idParente: parent.idParente,
          disabled: false
        }
      } else {
        this.listParent.objects.push({
          idPatient: this.idPatient,
          idParent: parent.idParent,
          idParente: parent.idParente,
          disabled: false
        })
      }
    }
    this._patient.updatePatientFamille(this.idPatient, this.listParent.objects);
    this.closeFamilleModal();
  }

  async deleteParent(event: any) {
    const deleteParent: FamillePatient = {
      idParent: event.idParent,
      idParente: event.idParente,
      idPatient: this.idPatient,
      disabled: true,
    }
    this._patient.updatePatientFamille(this.idPatient, [deleteParent]);
    await this.refresh();
  }

  closeFamilleModal() {
    this.closeEmitter.emit();
  }

}
